<template lang="pug">
.e-receipt-profile-update-form
  v-form(ref="form")
    v-container.pa-0(fluid)
      base-text-divider 必填資料
      v-layout(wrap)
        v-flex(
          xs12
          sm3)
          v-text-field(
            v-model="firstName"
            label="姓*"
            outline)
        v-flex(
          xs12
          sm3)
          v-text-field(
            v-model="lastName"
            :error-messages="lastNameErrors"
            label="名*"
            outline
            required
            @input="$v.lastName.$touch()"
            @blur="$v.lastName.$touch()")
        v-flex(
          xs12
          sm3)
          v-select(
            v-model="region"
            :items="regionItems"
            :error-messages="regionErrors"
            item-value="value"
            item-text="text"
            label="地區*"
            outline
            @input="$v.region.$touch()"
            @blur="$v.region.$touch()")
        v-flex(
          xs12
          sm3)
          v-select(
            v-model="gender"
            :items="genderItems"
            :error-messages="genderErrors"
            item-value="value"
            item-text="text"
            label="性別*"
            outline
            required
            @input="$v.gender.$touch()"
            @blur="$v.gender.$touch()")
        v-flex(
          xs12
          sm7)
          v-text-field(
            v-model="address"
            :counter="60"
            :error-messages="addressErrors"
            label="地址*"
            outline
            @input="$v.address.$touch()"
            @blur="$v.address.$touch()")
        v-flex(
          xs12
          sm2)
          v-text-field(
            v-model="zipCode"
            :counter="3"
            :error-messages="zipCodeErrors"
            label="郵遞區號*"
            outline
            @input="$v.zipCode.$touch()"
            @blur="$v.zipCode.$touch()")
        v-flex(
          xs12
          sm3)
          v-text-field(
            v-model="phoneNumber"
            :counter="10"
            :error-messages="phoneNumberErrors"
            label="電話*"
            outline
            @input="$v.phoneNumber.$touch()"
            @blur="$v.phoneNumber.$touch()")
      base-text-divider 選填資料
      v-layout(wrap)
        v-flex(
          xs12
          sm3)
          v-menu(
            ref="birthMenu"
            v-model="birthMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            :return-value.sync="birthValue"
            lazy
            offset-y
            full-width
            min-width="290px")
            template(v-slot:activator="{ on }")
              v-text-field(
                v-model="birthValue"
                label="生日"
                readonly
                outline
                v-on="on")
            v-date-picker(
              v-model="birthValue"
              ref="birthPicker"
              locale="zh-TW"
              min="1900-1-1"
              :max="maxBirthDate"
              :year-format="yearFormatter"
              no-title
              scrollable
              @change="saveBirth")
              v-spacer
              v-btn(
                flat
                color="error"
                @click="birthMenu = false") 取消
        v-flex(
          xs12
          sm3)
          v-text-field(
            v-model="email"
            :counter="40"
            :error-messages="emailErrors"
            label="電子信箱"
            outline
            @input="$v.email.$touch()"
            @blur="$v.email.$touch()")
        v-flex(
          xs12
          sm3)
          v-text-field(
            v-model="phoneNumber_2"
            :counter="10"
            :error-messages="phoneNumber_2Errors"
            label="電話2"
            outline
            @input="$v.phoneNumber_2.$touch()"
            @blur="$v.phoneNumber_2.$touch()")
        v-flex(
          xs12
          sm3)
          v-text-field(
            v-model="career"
            :counter="20"
            :error-messages="careerErrors"
            label="職業"
            outline
            @input="$v.career.$touch()"
            @blur="$v.career.$touch()")
        v-flex(
          xs12
          sm3)
          v-text-field(
            v-model="homeland"
            :counter="10"
            :error-messages="homelandErrors"
            label="家鄉"
            outline
            @input="$v.homeland.$touch()"
            @blur="$v.homeland.$touch()")
      form-actions(
        :loading="formMixin_loading"
        @cancel="$emit('cancel')"
        @submit="submit") {{ formMixin_message }}
</template>
<script>
import { validationMixin } from "vuelidate";
import { required, maxLength, email, numeric } from "vuelidate/lib/validators";
import { formMixin } from "@/mixins";

import moment from "moment";
import REGIONS from "@/assets/tables/regions.json";
import GENDERS from "@/assets/tables/genders.json";
import { length } from "@/utils/validators";

export default {
  name: "EReceiptProfileUpdateForm",
  mixins: [validationMixin, formMixin],
  validations: {
    lastName: { required },
    region: { required },
    gender: { required },
    address: { maxLength: maxLength(60), required },
    zipCode: { numeric, length: length(3), required },
    phoneNumber: { numeric, maxLength: maxLength(10), required },
    birth: {},
    email: { email, maxLength: maxLength(40) },
    phoneNumber_2: { numeric, maxLength: maxLength(10) },
    homeland: { maxLength: maxLength(10) },
    career: { maxLength: maxLength(20) }
  },
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      regionItems: Object.keys(REGIONS).map(v => REGIONS[v]),
      genderItems: Object.keys(GENDERS).map(v => GENDERS[v]),
      birthMenu: false,
      birthValue: this.$utils.parseTimestamp(this.user.birth),
      maxBirthDate: moment(new Date()).format("YYYY-MM-DD"),
      //form data
      firstName: this.user.firstName,
      lastName: this.user.lastName,
      region: this.user.region,
      gender: this.user.gender,
      email: this.user.email,
      address: this.user.address,
      zipCode: this.user.zipCode,
      phoneNumber: this.user.phoneNumber,
      phoneNumber_2: this.user.phoneNumber_2,
      career: this.user.career,
      homeland: this.user.homeland
    };
  },
  computed: {
    birth() {
      return this.birthValue ? new Date(this.birthValue) : null;
    },
    lastNameErrors() {
      const errors = [];
      if (!this.$v.lastName.$dirty) return errors;
      !this.$v.lastName.required && errors.push("必填名字");
      return errors;
    },
    regionErrors() {
      const errors = [];
      if (!this.$v.region.$dirty) return errors;
      !this.$v.region.required && errors.push("必填所屬區域");
      return errors;
    },
    genderErrors() {
      const errors = [];
      if (!this.$v.gender.$dirty) return errors;
      !this.$v.gender.required && errors.push("必填性別");
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.email && errors.push("電子信箱格式錯誤");
      !this.$v.email.maxLength && errors.push("最多40個字母");
      return errors;
    },
    addressErrors() {
      const errors = [];
      if (!this.$v.address.$dirty) return errors;
      !this.$v.address.maxLength && errors.push("最多60個字");
      !this.$v.address.required && errors.push("請輸入地址");
      return errors;
    },
    zipCodeErrors() {
      const errors = [];
      if (!this.$v.zipCode.$dirty) return errors;
      !this.$v.zipCode.numeric && errors.push("請輸入數字");
      !this.$v.zipCode.length && errors.push("請輸入郵遞區號3碼");
      !this.$v.zipCode.required && errors.push("請輸入郵遞區號3碼");
      return errors;
    },
    phoneNumberErrors() {
      const errors = [];
      if (!this.$v.phoneNumber.$dirty) return errors;
      !this.$v.phoneNumber.numeric && errors.push("請輸入數字");
      !this.$v.phoneNumber.maxLength && errors.push("最多10個數字");
      !this.$v.phoneNumber.required && errors.push("請輸入電話");
      return errors;
    },
    phoneNumber_2Errors() {
      const errors = [];
      if (!this.$v.phoneNumber_2.$dirty) return errors;
      !this.$v.phoneNumber_2.numeric && errors.push("請輸入數字");
      !this.$v.phoneNumber_2.maxLength && errors.push("最多10個數字");
      return errors;
    },
    homelandErrors() {
      const errors = [];
      if (!this.$v.homeland.$dirty) return errors;
      !this.$v.homeland.maxLength && errors.push("最多10個字");
      return errors;
    },
    careerErrors() {
      const errors = [];
      if (!this.$v.career.$dirty) return errors;
      !this.$v.career.maxLength && errors.push("最多20個字");
      return errors;
    }
  },
  watch: {
    birthMenu(val) {
      val && setTimeout(() => (this.$refs.birthPicker.activePicker = "YEAR"));
    }
  },
  methods: {
    saveBirth(date) {
      this.$refs.birthMenu.save(date);
    },
    async submit() {
      const fields = [
        "firstName",
        "lastName",
        "region",
        "gender",
        "birth",
        "email",
        "address",
        "zipCode",
        "phoneNumber",
        "phoneNumber_2",
        "homeland",
        "career"
      ];
      const uid = this.user.uid;

      const res = await this.formMixin_submit(fields, "patch", `user/${uid}`);
    },
    yearFormatter(v) {
      return `民國 ${v - 1911} (${v})`;
    }
  }
};
</script>
